import { render, staticRenderFns } from "./finalReviewStepProperties.vue?vue&type=template&id=fe8bd296&"
import script from "./finalReviewStepProperties.vue?vue&type=script&lang=js&"
export * from "./finalReviewStepProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports